// extracted by mini-css-extract-plugin
export default {"labelCol":"Modals_labelCol__kaliw"};